import { render, staticRenderFns } from "./ReviewRate.vue?vue&type=template&id=0b427bb4"
import script from "./ReviewRate.vue?vue&type=script&lang=js"
export * from "./ReviewRate.vue?vue&type=script&lang=js"
import style0 from "./ReviewRate.vue?vue&type=style&index=0&id=0b427bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports